// @flow

export const SET_EQUIPMENT_GROUPING = 'SET_EQUIPMENT_GROUPING';
export const setEquipmentGrouping = (groupType: string) => ({
  type: SET_EQUIPMENT_GROUPING,
  payload: groupType,
});
